import React, { useEffect, useState, useRef, MutableRefObject } from 'react';
import { ApiService } from '../../api/ProjectInfoService';
import { ToastContainer, toast } from 'react-toastify';
import DynamicTable from '../tables/DynamicTable';
import { FileUpload} from 'primereact/fileupload';
import "./fileuploader.scss"
import { CircularProgress } from "@mui/joy";
import { Navigate } from 'react-router-dom';

const BestandenBox = ({ title, project} : any) => {

    const [files, setFiles] = useState<any[]>([]);
    const [file, setFile] = useState(null);
    const fileUploadReference = useRef<FileUpload>(null);

    useEffect(() => {
        
        // get data
        getFiles();

    },[]);

    const getFiles = async () => {
        toast.info("Bestanden worden opgehaald");
        ApiService.getFiles(project?.id).then((response :any) => {
            setFiles(response.data);
        }).catch((error :any) => {
            console.log(error);
            toast.error("Er is iets misgegaan bij het ophalen van de bestanden");
        });
    }
    const customBase64Uploader = async (event: any) => {
        // convert file to base64 encoded
        const file = event.files[0];
        const reader = new FileReader();
        let blob = await fetch(file.objectURL).then((r) => r.blob()); //blob:url

        reader.readAsDataURL(blob);

        reader.onloadend = async function () {
            
            const base64data = (reader.result as string).split(',')[1] ;
            try {
                await ApiService.uploadFile(project.id, base64data as string, file.name, file.type)
                toast.success("Bestand is succesvol geupload");
                await getFiles();
                setFiles(files);
            } catch (error) {
                console.log(error);
                toast.error("Er is iets misgegaan bij het uploaden van het bestand");
            }
            
        }

    
    

        if (fileUploadReference.current) {
            fileUploadReference.current.clear();
        }
        
      

        };

    return (
        
        <>
        <div className="box">
            <h2>Bestanden</h2>
            <DynamicTable
            projectId={project?.id}
            data={files}
            editable={true}
            downloadNeeded={true}
            columns={[
                {id: 13,label: "Id", property:'id'},
                {id: 10,label: "Naam", property:'name'},
                {id: 3 ,label: "Bestandsnaam", property:'fileName'},
                {id: 4 ,label: "Document Type", property:'documenttype.name'},
                {id: 12 ,label: "mimeType", property:'mimeType'},
                {id: 14 ,label: "fileContent", property:'fileContent'}
                ]}
            />
            <div className="card flex justify-content-center">
            <FileUpload ref={fileUploadReference} mode="advanced" chooseLabel="Kies je bestand en druk daarna op de knop Upload" name="fileupload" url="/api/upload" accept="" customUpload uploadHandler={customBase64Uploader} />
        </div>
        </div>
        <ToastContainer />
        </>
    );
};

export default BestandenBox;
